import { html, TemplateResult } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-bar-graphs.css.lit';

/**The IDB bar graphs component.
 * @element idb-bar-graphs
 */

interface ApiData {
  graphText: string;
  graphNumber: number;
  barWidth: number;
}
@customElement('idb-bar-graphs')
export class BarGraphs extends OutlineElement {
  static styles = [componentStyles];

  /**
   * Data list for bars
   */
  @property({ type: Array, attribute: 'item-list' })
  itemList: ApiData[];

  constructor() {
    super();
    this.itemList = [];
  }

  render(): TemplateResult {
    return html`
      <div class="wrapper">
        <ul class="bar-graphs">
          ${this.itemList.map((item, index) => {
            return html`
              <li>
                <idb-bar-graph-panel
                  graph-class="bar-graph-panel--item-${index + 1}"
                  graph-text=${item.graphText}
                  graph-number=${item.graphNumber}
                  bar-width=${item.barWidth}
                >
                </idb-bar-graph-panel>
              </li>
            `;
          })}
        </ul>
      </div>
    `;
  }
}
